import gql from 'graphql-tag'

export default gql`
mutation updateMyUserShippingAddress($id: ID!, $addressInput: UserShippingAddressInput!) {
    updateMyUserShippingAddress(address_id: $id, address: $addressInput) {
        id
    }
}
`
